module.exports = __webpack_public_path__ + "img/1-230109142634Q7.a2dc3d48.png";